import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CheckCircle, Loader2, XCircle } from "lucide-react";
import { API } from "../App";
import { useI18n } from "../lib/i18n";

const SubscriptionSuccessPage = ({ user }) => {
  const { locale, t } = useI18n();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }

    const checkStatus = async () => {
      try {
        const res = await axios.get(`${API}/subscription/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus("success");
        } else if (res.data.payment_status === "unpaid") {
          setStatus("pending");
          setTimeout(checkStatus, 3000);
        } else {
          setStatus("error");
        }
      } catch {
        setStatus("error");
      }
    };

    checkStatus();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full" data-testid="subscription-result">
        <CardContent className="p-8 text-center space-y-6">
          {status === "loading" || status === "pending" ? (
            <>
              <Loader2 className="w-16 h-16 text-primary mx-auto animate-spin" />
              <h2 className="font-heading text-2xl font-semibold">
                {t("subscription.verifying")}
              </h2>
            </>
          ) : status === "success" ? (
            <>
              <CheckCircle className="w-16 h-16 text-accent mx-auto" />
              <h2 className="font-heading text-2xl font-semibold">
                {t("subscription.success")}
              </h2>
              <p className="text-muted-foreground">
                {t("subscription.successMessage")}
              </p>
              <Link to={user?.role === "therapist" ? "/therapist" : "/patient"}>
                <Button className="w-full" data-testid="go-dashboard-btn">
                  {locale === "fr" ? "Aller au tableau de bord" : "Go to dashboard"}
                </Button>
              </Link>
            </>
          ) : (
            <>
              <XCircle className="w-16 h-16 text-destructive mx-auto" />
              <h2 className="font-heading text-2xl font-semibold">
                {locale === "fr" ? "Erreur de paiement" : "Payment error"}
              </h2>
              <p className="text-muted-foreground">
                {t("subscription.failedMessage")}
              </p>
              <Link to="/pricing">
                <Button variant="outline" className="w-full">
                  {t("subscription.retry")}
                </Button>
              </Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionSuccessPage;
